import moment from "moment";

/**
 * Build customer data JSON string based on project configuration and form values
 * @returns {string} customer data in JSON format
 */
export const buildCustomerData = (newProjectConfig, companyId, customerDataFormValues, customerDataNotes) => {
  const filteredConfig = newProjectConfig.filter(c => companyId === companyId);

  if (filteredConfig?.length === 0) {
    return "";
  }
  let customerData = [];
  filteredConfig.forEach(item => {
    customerData.push({
      key: item.key,
      value: customerDataFormValues[item.label] || "-",
      note: customerDataNotes[item.label] || "",
      label: item.label
    });
  });

  return JSON.stringify(customerData);
}


export const buildSummary = (newProjectConfig, companyId, formValues, notes) => {
  const filteredConfig = newProjectConfig.filter(c => c.companyId === companyId);

  if (filteredConfig?.length === 0) {
    return null;
  }
  // Build HTML layout
  let html = `
      <div style="display: flex; gap: 40px; max-width: 600px;">
        <div style="flex: 1; white-space: normal">
          <strong style="padding-left: 20px; ">IMPORTANT INFO</strong>
          <ul style="padding-left: 20px; ">
    `;

  filteredConfig.forEach(item => {
    const value = formValues[item.label] || "-";
    html += `<li>${item.label}: ${value}</li>`;
  });

  html += `
          </ul>
        </div>
        <div style="flex: 1; white-space: normal">
          <strong>Notes:</strong>
          <ul style="list-style-type: none; padding-left: 0">
    `;

  filteredConfig.forEach(item => {
    const note = notes[item.label] || "";
    html += `<li>${note}</li>`;
  });

  html += `
          </ul>
        </div>
      </div>
    `;

  return html;
};

export const highlightText = (text) => {
  // regex to catch "xx m2 GO" and "+xx m2"
  const parts = text?.split(/( \+?\d+\s*m2\s*GO| \+?\d+\s*m2)/g);

  return (
    <span style={{ color: "black" }}>
      {parts?.map((part, i) =>
        /(m2 GO|m2)/.test(part) && /\d/.test(part) ? (
          <span key={i} style={{ color: "red" }}>
            {part}
          </span>
        ) : (
          part
        )
      )}
    </span>
  );
}

export const formatDateLabel = (labelName, date) => {
  return date ? labelName + " on: " +
    moment(
      date
    ).format("MM-DD") +
    " at " +
    moment(
      date
    ).format("LT")
    : "";
}

export const formatAssignedAndMovedDate = (assignedDate, moveLabel, movedToDate) => {
  return <div style={{ display: "flex", flexDirection: "column", textAlign: "right" }}>
    <label
      type="text"
      className="date-input"
    >
      {formatDateLabel("Assigned", assignedDate)}
    </label>
    <label
      type="text"
      className="date-input"
    >
      {formatDateLabel(moveLabel, movedToDate)}
    </label>
  </div>;
}

